export enum ProjectState {
  Pending = 'Pending',
  Handed = 'Handed',
  Finished = 'Finished',
  Model = 'Model'
}
